// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__3F7gu","right":"styles_right__j8CLG"};